import React from 'react'
import { Link } from 'gatsby'

// import { rhythm, scale } from '../utils/typography'

import Header from './header'

class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    let header1 

    /* Using Layout in src/pages/index.js to wrap the main page too.
     * For rootPath=`/`, the landing page, set the max-width to screen
     * width, max-w-screen-xl. Rest of the content comes from src/pages/index.js
     * 
     * For the path `/blogindex` and `/<slug-of-blog>`, set the max width
     * to max-w-2xl; 
     * set the title to Tufan Blog, currently picked up from siteMetadata.
     */
    // console.log(JSON.stringify({location}, null, 2));
    // console.log(JSON.stringify({title}, null, 2));

    // For the '/' page I need a larger max-width. Right now all other paths
    // on this website are /blogindex and /<name-of-blog> for which I want
    // the max-width to be max-width-2xl for now.
    if (location.pathname === rootPath) {
      header1 = (
        // For the landing page set max width that applies to the rest of the landing page
        <div className="max-w-screen-xl"></div>
        // <h1
        //   style={{
        //     ...scale(1.5),
        //     marginBottom: rhythm(1.5),
        //     marginTop: 0,
        //   }}
        // >
        //   {/* I need to understand color inherit here */}
          // <Link className="shadow-none no-underline text-tufan-red"
            // style={{
            //   boxShadow: `none`,
            //   textDecoration: `none`,
            //   color: `inherit`,
            // }}
      //       to={`/`}
      //     >
      //     {title}
      //     </Link>
      //   </h1>
      )
    } else {
      header1 = (
        // This is the dimension of any page that is not `/`
        <div className="m-auto max-w-2xl">
        <div className="tufan-bold-text-home text-3xl mb-12 text-tufan-red"
        > 
          <Link className="shadow-none no-underline text-tufan-red"
            // style={{
            //   boxShadow: `none`,
            //   textDecoration: `none`,
            //   color: `inherit`,
            // }}
            to={`/blogindex`}
          >
            {title}
          </Link>
        </div>
        </div>
      )
    }
    // console.log(header1, null, 2);

    return (
      <div>
        {/* Header is the navbar on the top far right */}
        <Header/>
        {/* header1 has max-w-screen-xl for home page; 
          * max-w-2xl for `/blogindex` and `/<slug-of-blog>` */}
        {header1}
        {children}
        
        <footer>
          <center><a href="https://tufan.io">tufan.io</a></center>
          <center>{`Making it simple to create, manage & secure cloud applications.`}</center>
          {/* © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.org">Gatsby</a> */}
        </footer>
      </div>
    )
  }
}

export default Layout
